import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { get } from 'lodash'
import { useRouter } from 'next/router'

import Video from './video'
import Icon from '../../icon'
import Typography from '../../typography'
import RawHTML from '../../../common/raw-html'
import { useBreakpoint } from '../../../../hooks/breakpoint'

import Play from '../../icon/play.svg'
import Clock from '../../icon/clock.svg'
import Close from '../../icon/x.svg'
import ShareIcon from '../../icon/compartir.svg'
import Modal from '../../modal'
import Share from '../../share'

const Detail = ({ webinar }) => {
  const beginTime = moment(webinar.beginTime)

  const router = useRouter()
  const breakpoint = useBreakpoint()

  const [showing, setShowing] = useState(false)
  const [openShareModal, setOpenShareModal] = useState(true)

  const showContent = () => {
    setShowing(true)
  }

  const handleOpenShareModal = (value) => () => {
    setOpenShareModal(value)
  }

  const DetailItems = () => {
    return <>
      <div
        className={'flex flex-row items-center'}>
        <Clock
          width={20}
          height={20}
          className={'mr-2'} />
        <Typography>
          {beginTime.format('DD [de] MMMM [de] YYYY')}
        </Typography>
      </div>
    </>
  }

  const CallToShare = () => {
    return <div
      tag={'div'}
      className={
        classNames([
          'flex',
          'fex-row',
          'items-center'
        ])
      }
      onClick={handleOpenShareModal(true)}>
      <div
        className={
          classNames([
            'bg-white',
            'rounded-full',
            'mr-2',
            'cursor-pointer'
          ])
        }
        style={{
          width: '2rem',
          height: '2rem',
          padding: '0.375rem'
        }}>
        <ShareIcon
          width={20}
          height={20}
          className={'block t-0 text-green-600'} />
      </div>
      <Typography>
        Comparte este live
      </Typography>
    </div>
  }

  return <section
    className={
      classNames([
        'relative',
        'min-h-screen',
        'w-full',
        'bg-green-600',
        'lg:flex',
        'lg:flex-col',
        'lg:items-center',
        'lg:justify-center',
        'text-white'
      ])
    }>
    {
      breakpoint.lgAndUp
        ? <Close
          width={40}
          height={40}
          className={'absolute text-white cursor-pointer'}
          style={{
            top: '20px',
            right: '20px'
          }}
          onClick={() => router.back()} />
        : null
    }
    <div
      className={
        classNames([
          'relative',
          'container',
          'max-h-screen',
          'overflow-auto',
          'lg:-mx-4'
        ])
      }>
      <div
        className={
          classNames([
            'relative',
            'flex',
            'flex-col',
            'lg:flex-row',
            'pt-20',
            'lg:pt-0',
            'w-full'
          ])
        }>
        {
          breakpoint.lgAndUp
            ? null
            : <Close
              width={40}
              height={40}
              className={'absolute text-white cursor-pointer'}
              style={{
                top: '20px',
                right: '20px'
              }}
              onClick={() => router.back()} />
        }
        <div
          className={
            classNames([
              'w-full',
              'mb-4',
              'lg:w-1/2',
              'lg:px-4',
              'lg:mb-0'
            ])
          }>
          <div
            className={'relative w-full'}
            style={{
              height: 0,
              paddingTop: '56.25%'
            }}>
            <div
              className={
                classNames([
                  'absolute',
                  'w-full',
                  'bg-black-01',
                  'bottom-0',
                  'bg-center',
                  'bg-cover',
                  'bg-no-repeat'
                ])
              }
              style={{
                height: 0,
                paddingTop: '56.25%',
                backgroundImage: `url(${get(webinar, 'headerImage.meta.downloadUrl', '')})`
              }} />

            <div className={'absolute w-full bottom-0 top-0 flex items-center justify-center'}>
              {showing
                ? <Video
                  webinar={webinar} />
                : <div
                  style={{
                    width: '64px',
                    height: '64px'
                  }}
                  className={'bg-green-600 flex items-center justify-center rounded-full'}
                  onClick={showContent}>
                  <Icon
                    width={24}
                    height={24}
                    style={{ color: 'white' }}
                    svg={Play} />
                </div>
              }
            </div>
          </div>

          <div
            className={'mt-4 px-4 lg:px-0'}>
            {
              breakpoint.lgAndUp
                ? <DetailItems />
                : <CallToShare />
            }
          </div>
        </div>
        <div
          className={
            classNames([
              'w-full',
              'lg:w-1/2',
              'flex',
              'flex-col',
              'justify-between',
              'px-4'
            ])
          }>
          <div>
            <Typography
              size={breakpoint.mdAndUp ? 'six' : 'four'}
              weight={'black'}
              className={'mb-4'}>
              {webinar.title}
            </Typography>
            <Typography
              tag={'div'}
              size={'three'}
              weight={'regular'}
              className={'mb-4'}>
              <RawHTML html={webinar.summary} />
            </Typography>
            {
              breakpoint.lgAndUp
                ? null
                : <DetailItems />
            }
          </div>
          {
            breakpoint.lgAndUp
              ? <CallToShare />
              : null
          }
        </div>
      </div>
    </div>
    <Modal open={openShareModal} onClose={handleOpenShareModal(false)} >
      <Share url={`/webinars/${webinar.id}/${webinar.meta.slug}`} size={40} icon={null} extended />
    </Modal>
  </section>
}

Detail.propTypes = {
  webinar: PropTypes.object
}

export default Detail
